// @flow
import EmptyWarn from './EmptyWarn';

export default EmptyWarn;
